export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/check-circle-lite.54831064.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};